import {
  Observable,
  distinctUntilChanged,
  fromEvent,
  map,
  merge,
  startWith,
} from 'rxjs';
import { BreakpointWidth } from '../../constants/breakpoint-width.constant';

export function determineIsDesktop(): Observable<boolean> {
  return merge(
    fromEvent(window, 'resize'),
    fromEvent(window, 'orientationChange'),
  ).pipe(
    startWith(undefined),
    map(() => window.innerWidth >= BreakpointWidth.lg),
    distinctUntilChanged(),
  );
}

export function determineIsTablet(): Observable<boolean> {
  return merge(
    fromEvent(window, 'resize'),
    fromEvent(window, 'orientationChange'),
  ).pipe(
    startWith(undefined),
    map(
      () =>
        window.innerWidth > BreakpointWidth.sm &&
        window.innerWidth < BreakpointWidth.lg,
    ),
    distinctUntilChanged(),
  );
}

export function determineIsMobile(): Observable<boolean> {
  return merge(
    fromEvent(window, 'resize'),
    fromEvent(window, 'orientationChange'),
  ).pipe(
    startWith(undefined),
    map(() => window.innerWidth <= BreakpointWidth.sm),
    distinctUntilChanged(),
  );
}
